import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import TextareaTable from "./TextareaTable.vue";
import {TextAreaFieldType} from "@/components/business/crud/interface/FieldType";



import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: "large", show: "large"}
});

export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();



return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_textarea, {
      value: _unref(data)[_ctx.propName],
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
      placeholder: '请填写' + _ctx.info.title,
      allowClear: true,
      showCount: true,
      "auto-size": { minRows: 4, maxRows: 8 }
    }, null, 8, ["value", "placeholder"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", { class: "view" }, _toDisplayString(_unref(data)[_ctx.propName]), 513), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})